<template>
    <div>
        <buttonlist ref="SetBtn" @help="help"></buttonlist>
        <div style="display: flex;width:100%">
            <div style="margin-top: 10px;text-align: center;width:100%">
                <div>
                    <table>
                        <tr>
                            <td style="width:60px">{{ $t('getapi[1974]') }}</td>
                            <td style="width:150px;">
                                <el-input v-model="dataDetail.year" type="text" size="mini"></el-input>
                            </td>
                            <td v-if="activeName == 0">{{ $t('getapi[1975]') }}</td>
                            <td v-if="activeName == 0">
                                <el-select filterable v-model="dataDetail.month"  size="mini" style="margin-righ:20px">
                                    <el-option v-for="item in monthList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                </el-select>
                            </td>
                            <td v-if="activeName != 0">{{ $t('getapi[12710]') }}</td>
                            <td v-if="activeName != 0">
                                <el-select filterable v-model="dataDetail.monthstart"  size="mini" style="margin-righ:20px">
                                    <el-option v-for="item in monthList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                </el-select>
                            </td>
                            <td v-if="activeName != 0">{{ $t('getapi[12711]') }}</td>
                            <td v-if="activeName != 0">
                                <el-select filterable v-model="dataDetail.monthend"  size="mini" style="margin-righ:20px">
                                    <el-option v-for="item in monthList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                </el-select>
                            </td>
                            <!--<td>
                                <span style="color:red">执行状态：{{btn.execute == false?"执行中...":"未执行"}}</span>
                            </td>-->
                        </tr>
                    </table>
                </div>
                <div >
                    <el-tabs :tab-position="'top'" style="margin-top: 5px" v-model="activeName" @tab-click="selectInfo" >
                        <el-tab-pane :label="$t('getapi[13313]')" name="0" id="xpane-0">
                            <div style="text-align: left">
                                <el-button type="primary" size="mini" @click="search">{{$t('getapi[1980]')}}</el-button>
                                <el-input v-model="key" class="input-with-select" style="width:250px;margin-left:8px">
                                    <el-button slot="append" icon="el-icon-search" @click="position"></el-button>
                                </el-input>
                                <el-button type="primary" size="mini" @click="del" :disabled="selectDataSet.length == 0" style="margin-left:8px">{{$t('getapi[3889]')}}</el-button>
                                <el-button type="primary" size="mini" @click="exec" :disabled="!btn.execute || selectDataSet.length == 0">{{$t('getapi[5063]')}}</el-button>
                                <el-button type="primary" size="mini" @click="exp">{{$t('getapi[922]')}}</el-button>
                                <el-button type="primary" size="mini" @click="clear">{{$t('getapi[2026]')}}{{$t('getapi[6592]')}}</el-button>
                            </div>
                            <vxe-table
                                    ref="singleTable"
                                    :data="dataSet"
                                    v-loading="loading"
                                    :highlight-current-row="true"
                                    show-overflow-tooltip="true"
                                    border
                                    stripe
                                    resizable
                                    size="mini"
                                    :height="tableHeight"
                                    header-row-class-name="headerclass"
                                    show-overflow="tooltip"
                                    style="width: 100%; margin-top:0px"
                                    :row-class-name="tableRowClassName"
                                    @checkbox-change="handleSelectionChange"
                                    @checkbox-all="handleSelectionChangeAll"
                                    @checkbox-range-end="handleSelectionChange"
                                    :checkbox-config="{highlight: true, range: true}"
                                    :mouse-config="{selected:true, extension: true}"
                                    :sort-config="{
                                         multiple: true,
                                    }"
                            >
                                <vxe-table-column type="checkbox" align="center" width="40"></vxe-table-column>
                                <vxe-table-column show-overflow-tooltip field="category_first" :title="$t('getapi[169]')" width="100"></vxe-table-column>
                                <vxe-table-column show-overflow-tooltip field="category_second" :title="$t('getapi[170]')" width="100"></vxe-table-column>
                                <vxe-table-column show-overflow-tooltip field="category_third" :title="$t('getapi[171]')" width="100"></vxe-table-column>
                                <vxe-table-column show-overflow-tooltip field="Order_No" :title="$t('getapi[2206]')" width="100" sortable></vxe-table-column>
                                <vxe-table-column show-overflow-tooltip field="line_no" :title="$t('getapi[3868]')" width="150" sortable></vxe-table-column>
                                <vxe-table-column show-overflow-tooltip field="cost_year" :title="$t('getapi[4987]')" width="80"></vxe-table-column>
                                <vxe-table-column show-overflow-tooltip field="cost_month" :title="$t('getapi[4988]')" width="80"></vxe-table-column>
                                <vxe-table-column show-overflow-tooltip field="part_code" :title="$t('getapi[112]')" width="100"></vxe-table-column>
                                <vxe-table-column show-overflow-tooltip field="part_version" :title="$t('getapi[149]')" width="100"></vxe-table-column>
                                <vxe-table-column show-overflow-tooltip field="digest" :title="$t('getapi[7340]')" width="80"></vxe-table-column>
                                <vxe-table-column show-overflow-tooltip field="item_code" :title="$t('getapi[876]')" width="100"></vxe-table-column>
                                <vxe-table-column show-overflow-tooltip field="Customer_code" :title="$t('getapi[2610]')" width="100"></vxe-table-column>
                                <vxe-table-column field="Issue_Material_Amount" :title="$t('getapi[7481]')" align="right" width="100">
                                    <template slot-scope="scope">
                                        {{scope.row.Issue_Material_Amount | thousandth}}
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="Issue_Man_Amount" :title="$t('getapi[7482]')" align="right" width="100">
                                    <template slot-scope="scope">
                                        {{scope.row.Issue_Man_Amount | thousandth}}
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="Issue_Charge_Amount" :title="$t('getapi[7483]')" align="right" width="100">
                                    <template slot-scope="scope">
                                        {{scope.row.Issue_Charge_Amount | thousandth}}
                                    </template>
                                </vxe-table-column>
                            </vxe-table>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[8243]')" name="1" id="xpane-1">
                            <div style="text-align: left;display: flex">
                                <!--<el-button type="primary" size="mini" @click="download">{{$t('getapi[6506]')}}</el-button>
                                <el-upload
                                        class="upload-demo"
                                        ref="upload"
                                        :action="uploadurl"
                                        :on-preview="handlePreview"
                                        :on-remove="handleRemove"
                                        :on-change="handleChange"
                                        :on-success="handleSuccess"
                                        :on-error="handleError"
                                        :file-list="fileList"
                                        :limit="1"
                                        accept=".xlsx"
                                        style="margin-left: 8px"
                                >
                                    <el-button slot="trigger" size="mini" type="primary">{{$t('getapi[6507]')}}</el-button>
                                </el-upload>
                                <el-button type="primary" size="mini" @click="imp" style="margin-left: 5px">{{$t('getapi[370]')}}</el-button>-->
                                <el-button type="primary" size="mini" @click="searchother(0)">{{$t('getapi[1980]')}}</el-button>
                                <el-button type="primary" size="mini" @click="expother(0)">{{$t('getapi[922]')}}</el-button>
                                <!--<el-radio v-model="monthoryear1" label="1" style="margin-left: 8px">按年分摊</el-radio>
                                <el-radio v-model="monthoryear1" label="2">按月分摊</el-radio>-->
                                <el-button type="primary" size="mini" @click="audit(0)">{{$t('getapi[8250]')}}</el-button>
                                <el-button type="primary" size="mini" @click="delf(0)">{{$t('getapi[8251]')}}</el-button>
                            </div>
                            <vxe-table
                                    ref="singleTable1"
                                    :data="dataSet1"
                                    v-loading="loading"
                                    :highlight-current-row="true"
                                    show-overflow-tooltip="true"
                                    border
                                    stripe
                                    resizable
                                    size="mini"
                                    :height="tableHeight"
                                    header-row-class-name="headerclass"
                                    show-overflow="tooltip"
                                    style="width: 100%; margin-top:0px"
                                    :checkbox-config="{highlight: true, range: true}"
                                    :mouse-config="{selected:true, extension: true}"
                            >
                                <vxe-table-column show-overflow-tooltip field="code" :title="$t('getapi[2610]')" width="100"></vxe-table-column>
                                <!--<vxe-table-column show-overflow-tooltip field="code" :title="$t('getapi[2584]')" width="100"></vxe-table-column>-->
                                <vxe-table-column field="material_cost" :title="$t('getapi[8244]')" width="100" align="right">
                                    <template slot-scope="scope">
                                        {{scope.row.material_cost | thousandth}}
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="man_cost" :title="$t('getapi[8245]')" width="100" align="right">
                                    <template slot-scope="scope">
                                        {{scope.row.man_cost | thousandth}}
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="charge_cost" :title="$t('getapi[8246]')" width="100" align="right">
                                    <template slot-scope="scope">
                                        {{scope.row.charge_cost | thousandth}}
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column show-overflow-tooltip field="remark" :title="$t('getapi[143]')" width="150"></vxe-table-column>
                            </vxe-table>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[8247]')" name="2" id="xpane-2">
                            <div style="text-align: left;display: flex">
                                <el-button type="primary" size="mini" @click="searchother(1)">{{$t('getapi[1980]')}}</el-button>
                                <el-button type="primary" size="mini" @click="expother(1)">{{$t('getapi[922]')}}</el-button>
                                <!--<el-radio v-model="monthoryear2" label="1" style="margin-left: 8px">按年分摊</el-radio>
                                <el-radio v-model="monthoryear2" label="2">按月分摊</el-radio>-->
                                <el-button type="primary" size="mini" @click="audit(1)">{{$t('getapi[8250]')}}</el-button>
                                <el-button type="primary" size="mini" @click="delf(1)">{{$t('getapi[8251]')}}</el-button>
                            </div>
                            <vxe-table
                                    ref="singleTable2"
                                    :data="dataSet2"
                                    v-loading="loading"
                                    :highlight-current-row="true"
                                    show-overflow-tooltip="true"
                                    border
                                    stripe
                                    resizable
                                    size="mini"
                                    :height="tableHeight"
                                    header-row-class-name="headerclass"
                                    show-overflow="tooltip"
                                    style="width: 100%; margin-top:0px"
                                    :checkbox-config="{highlight: true, range: true}"
                                    :mouse-config="{selected:true, extension: true}"
                            >
                                <vxe-table-column show-overflow-tooltip field="code" :title="$t('getapi[3437]')" width="100"></vxe-table-column>
                                <!--<vxe-table-column show-overflow-tooltip field="code" :title="$t('getapi[546]')" width="100"></vxe-table-column>-->
                                <vxe-table-column field="material_cost" :title="$t('getapi[8244]')" width="100" align="right">
                                    <template slot-scope="scope">
                                        {{scope.row.material_cost | thousandth}}
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="man_cost" :title="$t('getapi[8245]')" width="100" align="right">
                                    <template slot-scope="scope">
                                        {{scope.row.man_cost | thousandth}}
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="charge_cost" :title="$t('getapi[8246]')" width="100" align="right">
                                    <template slot-scope="scope">
                                        {{scope.row.charge_cost | thousandth}}
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column show-overflow-tooltip field="remark" :title="$t('getapi[143]')" width="150"></vxe-table-column>
                            </vxe-table>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[8248]')" name="3" id="xpane-3">
                            <div style="text-align: left;display: flex">
                                <el-button type="primary" size="mini" @click="searchother(2)">{{$t('getapi[1980]')}}</el-button>
                                <el-button type="primary" size="mini" @click="expother(2)">{{$t('getapi[922]')}}</el-button>
                                <!--<el-radio v-model="monthoryear3" label="1" style="margin-left: 8px">按年分摊</el-radio>
                                <el-radio v-model="monthoryear3" label="2">按月分摊</el-radio>-->
                                <el-button type="primary" size="mini" @click="audit(2)">{{$t('getapi[8250]')}}</el-button>
                                <el-button type="primary" size="mini" @click="delf(2)">{{$t('getapi[8251]')}}</el-button>
                            </div>
                            <vxe-table
                                    ref="singleTable3"
                                    :data="dataSet3"
                                    v-loading="loading"
                                    :highlight-current-row="true"
                                    show-overflow-tooltip="true"
                                    border
                                    stripe
                                    resizable
                                    size="mini"
                                    :height="tableHeight"
                                    header-row-class-name="headerclass"
                                    show-overflow="tooltip"
                                    style="width: 100%; margin-top:0px"
                                    :checkbox-config="{highlight: true, range: true}"
                                    :mouse-config="{selected:true, extension: true}"
                            >
                                <vxe-table-column show-overflow-tooltip field="code" :title="$t('getapi[2610]')" width="100"></vxe-table-column>
                                <!--<vxe-table-column show-overflow-tooltip field="code" :title="$t('getapi[2584]')" width="100"></vxe-table-column>-->
                                <vxe-table-column field="charge_cost" :title="$t('getapi[8246]')" width="100" align="right">
                                    <template slot-scope="scope">
                                        {{scope.row.charge_cost | thousandth}}
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column show-overflow-tooltip field="remark" :title="$t('getapi[143]')" width="150"></vxe-table-column>
                            </vxe-table>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[8274]')" name="4" id="xpane-4">
                            <div style="text-align: left;display: flex">
                                <el-button type="primary" size="mini" @click="searchother(3)">{{$t('getapi[1980]')}}</el-button>
                                <el-button type="primary" size="mini" @click="expother(3)">{{$t('getapi[922]')}}</el-button>
                                <!--<el-radio v-model="monthoryear4" label="1" style="margin-left: 8px">{{$t('getapi[8899]')}}</el-radio>
                                <el-radio v-model="monthoryear4" label="2">{{$t('getapi[8900]')}}</el-radio>-->
                                <el-button type="primary" size="mini" @click="audit(3)">{{$t('getapi[8250]')}}</el-button>
                                <el-button type="primary" size="mini" @click="delf(3)">{{$t('getapi[8251]')}}</el-button>
                            </div>
                            <vxe-table
                                    ref="singleTable4"
                                    :data="dataSet4"
                                    v-loading="loading"
                                    :highlight-current-row="true"
                                    show-overflow-tooltip="true"
                                    border
                                    stripe
                                    resizable
                                    size="mini"
                                    :height="tableHeight"
                                    header-row-class-name="headerclass"
                                    show-overflow="tooltip"
                                    style="width: 100%; margin-top:0px"
                                    :checkbox-config="{highlight: true, range: true}"
                                    :mouse-config="{selected:true, extension: true}"
                            >
                                <vxe-table-column show-overflow-tooltip field="code" :title="$t('getapi[2610]')" width="100"></vxe-table-column>
                                <!--<vxe-table-column show-overflow-tooltip field="code" :title="$t('getapi[2584]')" width="100"></vxe-table-column>-->
                                <vxe-table-column field="material_cost" :title="$t('getapi[8244]')" width="100" align="right">
                                    <template slot-scope="scope">
                                        {{scope.row.material_cost | thousandth}}
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="man_cost" :title="$t('getapi[8245]')" width="100" align="right">
                                    <template slot-scope="scope">
                                        {{scope.row.man_cost | thousandth}}
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="charge_cost" :title="$t('getapi[8246]')" width="100" align="right">
                                    <template slot-scope="scope">
                                        {{scope.row.charge_cost | thousandth}}
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column show-overflow-tooltip field="remark" :title="$t('getapi[143]')" width="150"></vxe-table-column>
                            </vxe-table>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>

            <el-dialog v-dialogDrag :visible.sync="visShowMessage"  width="30%" :close-on-click-modal="false">
                <div style="text-align:	center;margin-top: 15px"><el-input v-model="textareaShowMessage" type="textarea" rows="10"></el-input></div>
                <span slot="footer" class="dialog-footer">
                    <el-button size="mini" @click="visShowMessage = false">{{ $t('getapi[2054]') }}</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    export default {
        name: '3_finscrapcostshare',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight-200
            }
        },
        data() {
            return {
                btn: {
                    execute: true,
                },
                dataDetail:{
                    year: '',
                    month: '',
                    monthstart:'',
                    monthend:'',
                },
                monthList: [
                    {
                        value: 1,
                        label:1
                    },
                    {
                        value: 2,
                        label:2
                    },
                    {
                        value: 3,
                        label:3
                    },
                    {
                        value: 4,
                        label:4
                    },
                    {
                        value: 5,
                        label:5
                    },
                    {
                        value: 6,
                        label:6
                    },
                    {
                        value: 7,
                        label:7
                    },
                    {
                        value: 8,
                        label:8
                    },
                    {
                        value: 9,
                        label:9
                    },
                    {
                        value: 10,
                        label:10
                    },{
                        value: 11,
                        label:11
                    },
                    {
                        value: 12,
                        label:12
                    }
                ],
                visShowMessage: false,
                textareaShowMessage: '',
                dataSet: [], //
                dataSet1:[],
                dataSet2:[],
                dataSet3:[],
                dataSet4:[],
                loading: false,
                selectDataSet: [],
                key: '',
                SelectIndex: 0,
                // 系统外成本
                activeName: '0', // 当前选择的分页
                uploadurl: '',
                fileList: [],
                fileUrl: '',
                monthoryear1: "1",
                monthoryear2: "1",
                monthoryear3: "1",
                monthoryear4: "1",
                scrollTop:0,
                scrollTop1:0,
                scrollTop2:0,
                scrollTop3:0,
                scrollTop4:0,
                sortRule: { field: null, order: null },
            };
        },
        beforeDestroy(){
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function(){
                    setTimeout(() => {
                        that.$processdata.initForm(that.SelectIndex)
                    }, 500);
                });
            },
        },
        beforeMount() {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            that.uploadurl = Common.Url + '/CostCalc/InvView/FinOutCostShareImportUpload?token=' + token;
        },
        mounted: function () {
            let that = this;
            that.dataDetail.year = new Date().getFullYear()
            that.dataDetail.month = new Date().getMonth() + 1
            that.dataDetail.monthstart = new Date().getMonth() + 1
            that.dataDetail.monthend = new Date().getMonth() + 1
            that.$nextTick(function () {
                that.$processdata.initForm()
            })
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
                that.$refs.singleTable2.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop2 = res.target.scrollTop
                },false)
                that.$refs.singleTable3.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop3 = res.target.scrollTop
                },false)
                that.$refs.singleTable4.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop4 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                    this.$refs.singleTable2.bodyWrapper.scrollTop =this.scrollTop2;
                    this.$refs.singleTable3.bodyWrapper.scrollTop =this.scrollTop3;
                    this.$refs.singleTable4.bodyWrapper.scrollTop =this.scrollTop4;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6592]"),this.$t("getapi[8045]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('');
            },
            tableRowClassName({row, rowIndex}) {
                row.index = rowIndex;
            },
            // 执行
            execute(val){
                let that = this
                that.$confirm(that.$t('getapi[8596]'), that.$t('getapi[194]'), {//'确定要执行嘛'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let that = this
                        let parm = {
                            TYear: that.dataDetail.year,
                            Month: that.dataDetail.month
                        }
                        that.btn.execute = false
                        that.$http.urlpost('/Fin/Wip/FinUpdateP_Parth', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                                if(res.PopupTxt != '' && res.PopupTxt != null){
                                    that.visShowMessage = true;
                                    that.textareaShowMessage = res.PopupTxt
                                }
                            }
                            that.btn.execute = true
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[6096]')
                        });
                    });
            },
            //查询
            search(){
                let that = this
                let parm = {
                    TYear: that.dataDetail.year,
                    Month: that.dataDetail.month
                }
                that.loading = true
                that.$http.urlpost('/CostCalc/InvView/GetFinScrapCostShare', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent
                    }
                    that.loading = false
                });
            },
            exec(){
                let that = this
                that.$confirm(that.$t('getapi[8596]'), that.$t('getapi[194]'), {//'确定要执行嘛'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let arr = []
                        for(let i = 0;i<that.dataSet.length;i++){
                            arr = [...arr,{
                                digest: that.dataSet[i].digest,
                                order_no: that.dataSet[i].Order_No,
                                line_no: that.dataSet[i].line_no,
                                part_code: that.dataSet[i].part_code,
                                part_version: that.dataSet[i].part_version
                            }]
                        }
                        let parm = {
                            costyear: that.dataDetail.year,
                            costmonth: that.dataDetail.month,
                            ls: arr
                        }
                        that.btn.execute = false
                        let loadingInstance = Loading.service(Common.maskoption1);
                        that.$http.urlpost('/CostCalc/InvView/FinScrapCostShare', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                                if(res.PopupTxt != '' && res.PopupTxt != null){
                                    that.visShowMessage = true;
                                    that.textareaShowMessage = res.PopupTxt
                                }
                            }
                            that.btn.execute = true
                            loadingInstance.close()
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[6096]')
                        });
                    });
            },
            // 多选
            handleSelectionChange({checked, records }) {
                let that = this;
                that.selectDataSet = records;
            },
            handleSelectionChangeAll({ records }){
                let that = this;
                that.selectDataSet = records;
            },
            del(){
                let that = this
                that.$confirm(that.$t('getapi[8608]'), that.$t('getapi[194]'), {//确定要删除嘛
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        for (let i = that.selectDataSet.length - 1; i >= 0; i--) {
                            that.dataSet.splice(that.selectDataSet[i].index, 1);
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[6096]')
                        });
                    });
            },
            clear(){
                let that = this
                that.$confirm(that.$t('getapi[8901]') + '('+that.dataDetail.year+that.$t('getapi[2484]')+that.dataDetail.month+that.$t('getapi[6345]') + ')，' +that.$t('getapi[8902]'), that.$t('getapi[194]'), {
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            TYear: that.dataDetail.year,
                            Month: that.dataDetail.month
                        }
                        that.loading = true
                        that.$http.urlpost('/CostCalc/InvView/DeleteFinScrapCostShare', parm, function (res) {
                            if (res.Success == 1) {
                                that.search()
                            }
                            that.loading = false
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[6096]')
                        });
                    });
            },
            position(){
                let that = this
                if(that.key == ''){
                    return
                }
                let row = null
                let index = 0
                for(let i =0;i<that.dataSet.length;i++){
                    if(that.key.toUpperCase() == that.dataSet[i].Order_No.toUpperCase() || that.key.toUpperCase() == that.dataSet[i].part_code.toUpperCase()){
                        row = that.dataSet[i]
                        index = i
                        break
                    }
                }
                if(row != null){
                    that.$refs.singleTable.setCurrentRow(row);
                    setTimeout(() => {
                        setTimeout(() => {
                            that.$refs.singleTable.clearScroll().then(() => {
                                this.$refs.singleTable.scrollTo(0, (24*index))
                            })
                        }, 200);
                    }, 0);
                }
            },
            exp(){
                let that = this
                let parm = {
                    costyear: that.dataDetail.year,
                    costmonth: that.dataDetail.month,
                    ls: that.dataSet
                }
                that.$http.urlpost('/CostCalc/InvView/FinScrapCostShareToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            selectInfo(tab, event) {
                let that = this;
                that.SelectIndex = tab.name
                that.$nextTick(function(){
                    that.$processdata.initForm(tab.name)
                });
            },
            /*系统外成本*/
            download(){
                let that = this
                let param={
                    url:'/CostCalc/InvView/GetFinOutCostShareImportTemplate'
                }
                Array.methods.DownLoadTemp(param);
            },
            handleChange(file, fileList) {
                let that = this;
                that.loading = true;
                console.log(file);
                if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(file.response.Msg);
                    } else {
                        if(file.response.DataContent.Lists.length>0){
                            that.fileUrl = file.response.DataContent.URL
                            that.dataSet1 = file.response.DataContent.dt;
                        }else{
                            that.$message.warning(that.$t('getapi[8711]'));//Excel中无数据！
                        }
                    }
                    that.loading = false;
                }
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg())
                } else {
                    if(res.DataContent.Lists.length>0){
                        that.fileUrl = res.DataContent.URL
                        that.dataSet1 = res.DataContent.dt;
                    }else{
                        that.$message.warning(that.$t('getapi[8711]'));//Excel中无数据！
                    }
                }
                that.fileList=[];
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log("handlePreview"+file);
            },
            imp(){
                let that = this
            },
            //执行分摊
            audit(type){
                let that = this
                let parm = {
                    order_type: type,
                    just_year: that.dataDetail.year,
                    just_month_start: that.dataDetail.monthstart,
                    just_month_end: that.dataDetail.monthend,
                }
                that.$http.urlpost('/CostCalc/InvView/FinOutCostShareAudit', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                    }
                });
            },
            // 删除系统外成本
            delf(type){
                let that = this
                let parm = {
                    order_type: type,
                    just_year: that.dataDetail.year,
                    just_month_start: that.dataDetail.monthstart,
                    just_month_end: that.dataDetail.monthend,
                }
                that.$http.urlpost('/CostCalc/InvView/DeleteFinOutCostShare', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.searchother()
                    }
                });
            },
            searchother(type){
                let that = this
                let parm = {
                    order_type: type,
                    just_year: that.dataDetail.year,
                    just_month_start: that.dataDetail.monthstart,
                    just_month_end: that.dataDetail.monthend,
                };
                that.$http.urlpost('/CostCalc/InvView/GetFinOutCostShare', parm, function (res) {
                    if (res.Success == 1) {
                        if(type == 0){
                            that.dataSet1 = res.DataContent
                        } else if(type == 1){
                            that.dataSet2 = res.DataContent
                        } else if(type == 2){
                            that.dataSet3 = res.DataContent
                        } else if(type == 3){
                            that.dataSet4 = res.DataContent
                        }
                        /*let data = res.DataContent
                        that.dataSet1 = []
                        that.dataSet2 = []
                        that.dataSet3 = []
                        that.dataSet4 = []
                        for(let i = 0;i<data.length;i++){
                            if(data[i].order_type == '系统外成本按客户分摊'){
                                that.dataSet1 = [...that.dataSet1,data[i]]
                            } else if(data[i].order_type == '系统外成本按项目分摊'){
                                that.dataSet2 = [...that.dataSet2,data[i]]
                            } else if(data[i].order_type == '系统外成本按客户运费分摊'){
                                that.dataSet3 = [...that.dataSet3,data[i]]
                            } else if(data[i].order_type == '系统外成本按客户其它费用分摊'){
                                that.dataSet4 = [...that.dataSet4,data[i]]
                            }
                        }*/
                    }
                });
            },
            expother(type){
                let that = this
                let parm = {
                    order_type: type,
                    just_year: that.dataDetail.year,
                    just_month_start: that.dataDetail.monthstart,
                    just_month_end: that.dataDetail.monthend,
                }
                that.$http.urlpost('/CostCalc/InvView/GetFinOutCostShareToExcel', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    .tab{
        border-spacing: 20px;
        font-size: 18px;
    }
    .el-table--mini, .el-table--small, .el-table__expand-icon{
        border: 1px solid #9cc1f5
    }
</style>
